import { api, setTokens, clearTokens } from './client';
export async function login(initData) {
    const data = await api('/api/auth/login', {
        method: 'POST',
        body: JSON.stringify({ initData }),
    });
    setTokens(data.accessToken, data.refreshToken);
    return data;
}
export async function refresh(refreshToken) {
    const data = await api('/api/auth/refresh', {
        method: 'POST',
        body: JSON.stringify({ refreshToken }),
    });
    setTokens(data.accessToken, data.refreshToken);
    return data;
}
export async function getMe() {
    return api('/api/auth/me');
}
export function logout() {
    clearTokens();
    window.location.href = '/';
}
